<template>
    <div class="device-selector">
        <p class="device-selector-title">{{ title }}</p>
        <el-select 
            class="device-selector-content" 
            ref="select" 
            filterable 
            remote 
            reserve-keyword 
            placeholder="请选择设备"
            v-model="value" 
            :remote-method="onFilter" 
            :popper-append-to-body="false"
            :loading="loading"
        >
            <el-option 
                v-for="item in dataArray" 
                :key="item.id" 
                :value="item.sn" 
                :label="item.sn"
            >
                <span>{{ item.sn }}  </span>
                <span style="float: right; color: #8492a6; font-size: 13px"> {{ item?.userName}} {{ item.userStatusDesc }}</span>
            </el-option>
        </el-select>

      
    </div>
</template>

<script>
export default {
    model: {
        prop: "initValue",
        event: "onInitValueChanged"
    },

    props: {
        title: {
            type: String,
            default: "设备选择"
        },
        hospitalId: Number,
        initValue: Number|String,
        defaultSn: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            loading: false,
            currentPage: 1,
            keyWord: "",
            pageSize: 20,
            dataArray: [],
            isLastPage: false,
            value: undefined
        }
    },

    mounted() {
        this.$refs.select.$refs.scrollbar.$refs.wrap.addEventListener('scroll', this.onScroll);
        // 如果有默认的设备SN，设置为搜索关键词
        if (this.defaultSn) {
            this.keyWord = this.defaultSn;
        }
        this.getDeviceList();
    },

    methods: {
        onScroll() {
            if (this.isLastPage) return;
            let e = this.$refs.select.$refs.scrollbar.$refs.wrap;
            let isBottom = e.scrollHeight - e.scrollTop <= e.clientHeight;
            if (isBottom) {
                this.loadMore();
            }
        },

        onFilter(value) {
            this.keyWord = value;
            this.currentPage = 1;
            this.dataArray = [];
            this.getDeviceList();
        },

        loadMore() {
            if (!this.loading) {
                this.currentPage += 1;
                this.getDeviceList();
            }
        },

        async getDeviceList() {
            try {
                this.loading = true;
                const params = {
                    sn: this.keyWord,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    hospitalId: this.hospitalId
                };
                
                const response = await this.$api.getDeviceList(params);
                this.loading = false;
                
                if (response && response.list) {
                    this.dataArray = this.dataArray.concat(response.list);
                    console.log('this.dataArray',this.dataArray)
                    // 计算是否是最后一页
                    this.isLastPage = this.currentPage >= Math.ceil(response.total / this.pageSize);
                    
                    // 如果有默认SN且当前value为空，自动选中匹配的设备
                    if (this.defaultSn && !this.value && this.currentPage === 1) {
                        const defaultDevice = response.list.find(device => device.sn === this.defaultSn);
                        if (defaultDevice) {
                            this.value = defaultDevice.sn;
                        }
                    }
                }
            } catch (error) {
                this.loading = false;
                console.error('获取设备列表失败:', error);
                this.$toast.showRed('获取设备列表失败');
            }
        },
    },

    watch: {
        initValue(value) {
            this.value = value;
        },

        value(value) {
            this.$emit("onInitValueChanged", value);
        },
        
        hospitalId() {
            // 医院ID变化时重新获取设备列表
            this.currentPage = 1;
            this.dataArray = [];
            this.getDeviceList();
        }
    }
}
</script>

<style lang="scss" scoped>
.device-selector {
    background-color: #F6F6F6;
    box-sizing: border-box;
    width: rem(260);
    height: rem(44);
    padding-left: rem(10);
    border-radius: rem(6);
    display: flex;
    align-items: center;

    &-title {
        color: #444C72;
        font-size: rem(14);
        margin-right: rem(15);
        white-space: nowrap;
    }

    &-content {
        margin-top: rem(2);
        width: rem(172);

        ::v-deep .el-input__inner {
            background-color: #F6F6F6;
            border-color: transparent !important;
            width: 100%;
        }

        ::v-deep .el-input__suffix {
            background-color: #F6F6F6;
        }

        ::v-deep .el-select-dropdown {
            margin-top: rem(5) !important;
        }

        ::v-deep .el-select-dropdown__item {
            height: auto;
            max-height: none;
            padding: rem(8) rem(20);
            line-height: rem(20);
        }
    }
}
</style>